// tslint:disable:max-line-length

import React from 'react';

export const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="8 15.5 15.5 8 8 0.5 6.62 1.88 11.78 7.03 0.5 7.03 0.5 8.97 11.78 8.97 6.62 14.12 8 15.5" />
    </svg>
  );
};
